import React from "react";
// reactstrap components
import {
  Row,
  Col,
  Button
} from "reactstrap";

class Step3 extends React.Component {
  
  render() {

    const {
      isLoading,
      successMessage,
      errorMessage
    } = this.props;

    return (
      <>
        <Row className="justify-content-center mt-5">
          <Col sm="10">
            <p>Your report is ready to be created.</p>
            <p>Click "Create report" to proceed. It will be downloaded automatically once it's complete.</p>
          </Col>
          <Col sm="10 mt-3">
            {isLoading && <p className="text-info">Creating report...Please don't refresh or leave the page until it's ready</p>}
            {successMessage && <p className="text-success">{successMessage}</p>}
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
          </Col>
        </Row>
        <Row className="d-flex justify-content-lg-around mt-3">
            <Button 
                onClick={this.props.previousStep}
                disabled={!this.props.previousStep}
            >
                Previous Step
            </Button>
            <Button 
                onClick={() => this.props.generateReport()}
                disabled={isLoading}
            >
                {isLoading ? "Creating..." : "Create report"}
            </Button>
        </Row>
      </>
    );
  }
}

export default Step3;
